import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'agenx-checkbox',
  standalone: true,
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
})
export class AgenxCheckboxComponent {
  /**
   * Input label
   *
   * @type {string}
   * @memberof AgenxCheckboxComponent
   */
  @Input() label: string = 'Input label';

  /**
   * Input idInput
   *
   * @type {string}
   * @memberof AgenxCheckboxComponent
   */
  @Input() idInput: string = 'idInput';

  /**
   * Input nameInput
   *
   * @type {string}
   * @memberof AgenxCheckboxComponent
   */
  @Input() nameInput: string = 'nameInput';

  @Input() checked: boolean = false;

  @Input() value: string = 'value';

  /**
   * Current classes of the input
   *
   * @type {Record<string, boolean>}
   * @memberof AgenxCheckboxComponent
   */
  labelClasses: Record<string, boolean> = {};

  /**
   * Input form control
   *
   * @type {FormControl}
   * @memberof AgenxCheckboxComponent
   */
  @Input() control: FormControl = new FormControl();

  /**
   * Alert type
   *
   * @type {('error' | 'warning' | 'info')}
   * @memberof AgenxCheckboxComponent
   */
  @Input() type: 'error' | 'warning' | 'info' = 'info';
  @Output() valueSend = new EventEmitter<string>();

  /**
   * Function to set the current classes of the button
   *
   * @memberof AgenxAlertComponent
   */
  setCurrentClasses() {
    this.labelClasses = {
      'agenx-checkbox-warning': this.type === 'warning',
      'agenx-checkbox-danger': this.type === 'error',
      'agenx-checkbox': this.type === 'info',
    };
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change['type']) {
      this.setCurrentClasses();
    }
  }

  ngOnInit(): void {
    this.setCurrentClasses();
  }

  sendValue() {
    this.valueSend.emit(this.value)
  }
}
